// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

export class QueryParameterNames {
    public static BotId: string = "botid";
    public static CustomSpeechDeploymentId: string = "cid";
    public static CustomVoiceDeploymentId: string = "deploymentId";
    public static EnableAudioLogging: string = "storeAudio";
    public static EnableLanguageId: string = "lidEnabled";
    public static EnableWordLevelTimestamps: string = "wordLevelTimestamps";
    public static EndSilenceTimeoutMs: string = "endSilenceTimeoutMs";
    public static SegmentationSilenceTimeoutMs: string = "segmentationSilenceTimeoutMs";
    public static Format: string = "format";
    public static InitialSilenceTimeoutMs: string = "initialSilenceTimeoutMs";
    public static Language: string = "language";
    public static Profanity: string = "profanity";
    public static RequestBotStatusMessages: string = "enableBotMessageStatus";
    public static StableIntermediateThreshold: string = "stableIntermediateThreshold";
    public static StableTranslation: string = "stableTranslation";
    public static TestHooks: string = "testhooks";
    public static Postprocessing: string = "postprocessing";
    public static CtsMeetingId: string = "meetingId";
    public static CtsDeviceId: string = "deviceId";
    public static CtsIsParticipant: string = "isParticipant";
}
